<template>
<with-actions>
  <sweet-modal ref="quote_modal" @close="selected_customer = null">
    <div class="text-left">
      <customer-creation-quote v-if="selected_customer" v-model="selected_customer.quote" :customer="selected_customer"></customer-creation-quote>
    </div>
  </sweet-modal>
  <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_customers')">
    <router-link class="mr-2 btn btn-outline-primary" :to="{name: 'change_logs'}" tag="button" v-if="can('read_change_logs')">{{ 'routes_change_logs'|t }}</router-link>
    <div class="dropdown">
      <router-link class="btn btn-success" :to="{name: 'customers_create'}" tag="button">{{ 'routes_customers_create'|t }}</router-link>
      <button class="btn btn-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="sr-only"></span></button>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" :to="{name: 'customers_demo'}" tag="button">{{ 'routes_customers_demo'|t }}</router-link>
        <router-link class="dropdown-item" :to="{name: 'customers_migrate'}" tag="button">{{ 'routes_customers_migration'|t }}</router-link>
      </div>
    </div>
  </div>
  <p class="mb-0 text-muted"><span>{{ 'found' | t }} {{ record_count }}</span><span class="pl-1" v-if="record_count === 1">{{ 'customer' | t}}</span><span class="pl-1" v-else>{{ 'customers' | t}}</span></p>
  <lazy-table ref="table" v-model="customers" model="customers" :params="query" :autoload="false" @meta="x => record_count = x.record_count">
    <customer-filters-whitelabel @change="update_query" slot="header" v-if="managed_organization"></customer-filters-whitelabel>
    <customer-filters @change="update_query" slot="header" v-else></customer-filters>
    <div class="m-3 mt-4">
      <table class="table table-hover table-responsive w-100 d-block d-md-table">
        <thead>
          <tr>
            <th v-if="!managed_organization"></th>
            <sortable-th v-model="query.sort" sort_key="name">{{ 'name'|t }}</sortable-th>
            <sortable-th v-model="query.sort" sort_key="service_status">{{ 'service_status'|t }}</sortable-th>
            <th v-if="!managed_organization">{{ 'subscription_status' | t }}</th>
            <th>{{ 'onboarding_status' | t }}</th>
            <th>{{ 'plan' | t }}</th>
            <th v-if="!managed_organization">{{ 'payment_method' | t }}</th>
            <th>{{ 'tags' | t | titlecase }}</th>
            <sortable-th v-model="query.sort" sort_key="shipments_last_week">{{ 'shipments_last_week'|t }}</sortable-th>
            <th v-if="can('read_organizations')">{{ 'organization' | t | titlecase }}</th>
            <sortable-th class="text-right" v-model="query.sort" sort_key="created_at">{{ 'created_at'|t }}</sortable-th>
            <th v-if="!isWhiteLabel"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers">
            <td v-if="!managed_organization">
              <customer-vat-status :customer="customer"></customer-vat-status>
            </td>
            <td>
              <router-link :to="{name: 'customers_show', params: {customer_id: customer.id }}" role="button"><strong>{{ customer.name }}</strong>
                <div class="pt-1 text-mono">{{ customer.tenant_name }}</div>
              </router-link>
            </td>
            <td><span class="badge badge-success" v-if="customer.service_status == 'running'">{{'Running'}}</span><span class="badge badge-warning" v-if="customer.service_status == 'test'">{{'Test'}}</span><span class="badge badge-danger" v-if="customer.service_status == 'disabled'">{{'Disabled'}}</span><span class="badge badge-dark" v-if="customer.service_status == 'quote'">{{'Quote'}}</span><span class="badge badge-dark" v-if="customer.service_status == 'free_trial'">{{'Free Trial'}}</span></td>
            <td v-if="!managed_organization"><span class="badge badge-warning mr-2" v-if="customer.quote && customer.subscription && customer.quote.generation != customer.subscription.generation">Pending Plan Upgrade</span><span class="badge" :class="{'active': 'badge-success', 'trial': 'badge-warning', 'unbilled': 'badge-dark', 'cancelled': 'badge-danger'}[ subscription_status(customer)]   ">{{subscription_status(customer)|titlecase }}</span><span class="badge ml-2 badge-dark" v-if="customer.quote && !customer.quote.is_forced">{{'has_quote'|t }}</span><span class="badge ml-2 badge-dark" v-if="customer.quote && customer.quote.is_forced">{{'has_force_quote'|t }}</span></td>
            <td>
              <onboarding-status :status="customer.onboarding_status"></onboarding-status>
            </td>
            <td>
              <template v-if="customer.third_party_managed"><span v-if="customer.billed_plan">{{ customer.billed_plan.name }}</span></template>
              <template v-else><span v-if="customer.subscription"><span v-if="customer.subscription.subscription_type == 'white_label'"><em>{{ 'white_label_subscription' |t }}</em></span><span v-else>
                    <customer-projected-usage :customer="customer"></customer-projected-usage></span></span></template>
            </td>
            <td v-if="!managed_organization"><i class="fa fa-credit-card" v-if="customer.payment_method == 'credit_card'" :class="{'text-danger': customer.credit_card_count &lt; 1}"></i><i class="fa fa-file-o" v-if="customer.payment_method == 'invoice'" :class="{'text-danger': customer.overdue_invoices > 0}"></i></td>
            <td><span class="badge badge-light mr-2" v-for="tagging in customer.taggings">{{ tagging.tag.name }}</span></td>
            <td class="text-center">
              <customer-shipment-usage :customer="customer" :plans="plans" :compare="!managed_organization"></customer-shipment-usage>
            </td>
            <td v-if="can('read_organizations')">{{ customer.organization.name }}</td>
            <td class="text-right">{{ customer.created_at | datetime}}</td>
            <td class="text-right" v-if="!isWhiteLabel">
              <div class="btn btn-outline-primary btn-sm" @click="open_quote_modal(customer)"><span v-if="!customer.quote">Create Quote</span><span v-else>Edit Quote</span></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </lazy-table>
</with-actions>
</template>
<script>
import Api from "@/store/jsonapi";

export default {
  data: function () {
    return {
      customers: [],
      query: {
        include: "organization,taggings.tag,billed_plan",
        sort: "-created_at",
        filter: {},
      },
      record_count: 0,
      plans: [],
      filterSpecificView: null,
      selected_customer: null,
    };
  },
  mounted() {
    this.$store.commit("setBreadcrumbs", [
      { to: { name: "customers" }, text: "Customers" },
    ]);
  },
  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      },
    },
    "query.filter": function (newValue, formerValue) {
      let filterSpecificView = null;
      let viewSpecificFilterKeys = ["onboarding_status"];
      _.forEach(newValue, function (value, filterKey) {
        filterSpecificView = _.find(
          viewSpecificFilterKeys,
          function (viewSpecificFilterKey) {
            return filterKey === viewSpecificFilterKey;
          }
        );
      });

      this.filterSpecificView = filterSpecificView;
    },
  },
  created() {
    Api.findAll("plans").then((x) => {
      const unique_plans = [
        ...new Set(x.data.map((item) => item.included_shipments)),
      ];
      this.plans = unique_plans.sort((a, b) => a - b);
    });
  },
  computed: {
    managed_organization() {
      let org = this.$store.state.currentOrganization;
      if (org) {
        return org.is_managed;
      }
    },
  },
  methods: {
    open_quote_modal(customer) {
      this.selected_customer = customer;
      this.$refs.quote_modal.open();
    },
    subscription_status(customer) {
      if (customer.subscription) {
        return customer.subscription.status;
      } else {
        return "";
      }
    },
    update_query(q) {
      this.query.filter = q.filter;
    },
  },
};
</script>

<style scoped>
table.table th,
table.table td {
  border-top: none;
}

.text-mono {
  font-family: "Courier New", Courier, monospace;
}
</style>

<style>
button .fa {
  margin-right: 5px;
  font-size: 16px;
}
</style>
